// extracted by mini-css-extract-plugin
export default {"btn":"CrrButton_btn__nTllo"};